import getEnvConfig from "./config";

const gameConfig = window.GameConfig;

export const isGameDown = (): boolean => {
  const gameId = getEnvConfig().webgl_game_id;
  return gameConfig.isDown[gameId];
};

export const getTokenRefreshInterval = (): number => {
  return gameConfig.tokenRefreshInterval;
};

